export default __webpack_public_path__ + "static/media/forigenemployemnt.b96d1bdd.png";